import { FeatureFlagsConfig } from "./types";

import { exploration } from "./exploration";
import { indicators } from "./indicators";
import { descriptives } from "./descriptives";
import { portal } from "./portal";
import { patients } from "./patients";
import { patientsLikeMe } from "./patients-like-me";
import { overview } from "./overview";
import { dataRequest } from "./data-request";
import { shared } from "./shared";

export * from "./types";

export const featureFlags: FeatureFlagsConfig = {
    exploration,
    indicators,
    descriptives,
    portal,
    patients,
    "patients-like-me": patientsLikeMe,
    overview,
    "data-request": dataRequest,
    shared,
} as const;
